import { ReactElement } from 'react'
import FormCollapsibleSection from './FormCollapsibleSection'
import { CollapsibleBoxSectionProps } from './collapsibleSectionProps'
import { FormSectionIcons } from './icons'

const CollapsibleDocumentationBoxSection = ({
  children,
  defaultExpanded = false,
  dataCy,
  isEmpty,
}: CollapsibleBoxSectionProps): ReactElement | null => {
  return (
    <FormCollapsibleSection
      label="Dokumentation"
      startIcon={FormSectionIcons.documentation}
      defaultExpanded={defaultExpanded}
      dataCy={dataCy}
      isEmpty={isEmpty}
    >
      {children}
    </FormCollapsibleSection>
  )
}

export default CollapsibleDocumentationBoxSection
